'use client';

import { checkVideosApi } from '@repo/sdk';
import { useEffect, useMemo, useState } from 'react';

export function useVideoCheck(vaultPaths: (string | null)[]) {
  const [results, setResults] = useState<Record<string, boolean>>({});
  const paths = useMemo(() => vaultPaths.filter((p): p is string => p !== null), [vaultPaths]);
  useEffect(() => {
    if (paths.length === 0) {
      return;
    }

    checkVideosApi({ paths })
      .then(setResults)
      .catch(() => {});
  }, [paths]);

  return results;
}
